import React from 'react';
import styles from './Progressbar.module.scss';

// eslint-disable-next-line react/prop-types
function Progressbar({ percentage = 10, maxValue = 100, title = ''}) {
  return (
    <div className={styles.progressBarContainer}>
      <span className={styles.title}>{title}</span>
      <progress className={styles.progressBar} value={percentage} max={maxValue}></progress>
    </div>
  )
}


export default Progressbar;